import { render, staticRenderFns } from "./search-icon.vue?vue&type=template&id=6f82cab2&"
import script from "./search-icon.vue?vue&type=script&lang=js&"
export * from "./search-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports